/**
 * PERMISSIONS CONFIG
 * 
 * Roles:
 * - clinicSystemAdmin: admin === 1 OR clinician === 1000 (do and see everything)
 * - clinicSystemAdmin: clinician === 1000 (do and see everything)
 * - clinicAdmin: clinician === 100 (do and see everything)
 * - manager: manager === 1 AND clinician === 0 (see everything except patients, only write in settings/personal)
 * - specialist: clinician === 1 (see home, patients and settings, does not write in settings/clinic nor add staff)
 */

interface PermissionSet {
  canView: string[]
  canWrite: string[]
  restricted: string[]
}

type PermissionsConfig = {
  [key: string]: PermissionSet
}

export const PERMISSIONS: PermissionsConfig = {
  clinicSystemAdmin: {
    canView: ['*'],
    canWrite: ['settings/personal'],
    restricted: []
  },

  clinicAdmin: {
    canView: ['*'],
    canWrite: ['*'],
    restricted: []
  },

  manager: {
    canView: ['home', 'settings'],
    canWrite: ['settings/personal'],
    restricted: ['patients', 'staff', 'settings/clinic']
  },

  specialist: {
    canView: ['home', 'patients', 'settings'],
    canWrite: ['settings/personal'],
    restricted: ['staff', 'settings/clinic']
  },

  regularUser: {
    canView: ['home', 'settings'],
    canWrite: ['settings/personal'],
    restricted: ['patients', 'staff', 'settings/clinic']
  }
}

